import './App.css';
import React from "react";
import { Route, Routes} from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider} from '@mui/x-date-pickers';

import 'bootstrap/dist/css/bootstrap.min.css';

import Layout from './pages/Layout';
import Err404 from './pages/Err404';
import Login from './pages/Login'

import RoomActivity from './pages/RoomActivity'
import StationReport from './pages/StationReport'
import SmsContacts from './pages/SmsContacts'
import ErrorActivityLog from './pages/ErrorActivityLog'
import AssignRoom from './pages/AssignRoom'
import Rooms from './pages/Rooms'
import Settings from './pages/Settings'
import Logout from './pages/Logout'

import Dashboard from './pages/Dashboard'

import Register from './pages/Register'
import ResetPassword from './pages/ResetPassword'

import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";


function App() {


  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>

    <UserAuthContextProvider>
      <Routes>
        <Route path="/" index element={<Login />} />
        <Route path="login" index element={<Login />} />
        <Route path="izeem-admin/register" element={<Register />} />
        <Route path="reset_password" element={<ResetPassword />} />
        <Route path="Logout" element={<Logout />} />
        <Route path="*" element={<Err404 />} />

        <Route element={<Layout header="ROOM ACTIVITY" id="RoomActivity" />}>
          <Route path="RoomActivity"
            element={
              <ProtectedRoute>
                <RoomActivity />
              </ProtectedRoute>
            } />
        </Route>

        <Route element={<Layout header="STATION REPORT" id="StationReport" />}>
          <Route path="StationReport"
            element={
              <ProtectedRoute>
                <StationReport />
              </ProtectedRoute>
            } />
        </Route>

          <Route element={<Layout header="SMS CONTACTS" id="SmsContacts" />}>
          <Route path="SmsContacts" element={
            <ProtectedRoute>
              <SmsContacts />
            </ProtectedRoute>
          } />
        </Route>

          <Route element={<Layout header="ERROR ACTIVITY LOG" id="ErrorActivityLog" />}>
          <Route path="ErrorActivityLog" element={
            <ProtectedRoute>
              <ErrorActivityLog />
            </ProtectedRoute>
          } />
        </Route>

          <Route element={<Layout header="ASSIGN ROOM" id="AssignRoom" />}>
          <Route path="AssignRoom" element={
            <ProtectedRoute>
              <AssignRoom />
            </ProtectedRoute>
          } />
        </Route>

          <Route element={<Layout header="ROOMS" id="Rooms" />}>
          <Route path="Rooms" element={
            <ProtectedRoute>
              <Rooms />
            </ProtectedRoute>
          } />
        </Route>

        <Route element={
          <ProtectedRoute>
            <Layout header="SETTINGS" id="Settings" />
          </ProtectedRoute>
        }>
          <Route path="Settings" element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          } />
        </Route>


        <Route element={<Layout header="DASHBOARD" />}>
          <Route path="dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
        </Route>



      </Routes>
    </UserAuthContextProvider>
    </LocalizationProvider>


  );
}

export default App;
